"use client";

export function addArrayElements(arr: string | any[]) {
  if (!arr || arr.length === 0) {
    return null; // Handle empty array case
  }

  let result = 0;
  for (let num of arr) {
    result += num;
  }

  return result;
}

export function whatsAppLink(mobileNumber: string) {
  let whatsappLink: any = `https://wa.me/${mobileNumber}`;

  // Open the WhatsApp link in a new tab/window
  window.open(whatsappLink, "_blank");
}
